import { render, staticRenderFns } from "./IsJoinLowPv.vue?vue&type=template&id=1ac0fb6c&scoped=true&"
import script from "./IsJoinLowPv.vue?vue&type=script&lang=js&"
export * from "./IsJoinLowPv.vue?vue&type=script&lang=js&"
import style0 from "./IsJoinLowPv.vue?vue&type=style&index=0&id=1ac0fb6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac0fb6c",
  null
  
)

export default component.exports